import { createServerFn } from '@tanstack/react-start';
import { getRequest } from '@tanstack/react-start/server';

import { toPublicAuthSession } from '~/modules/auth/mappers.ts';
import type { PublicAuthSession } from '~/modules/auth/types.ts';

import { getAuthSession } from './session.server.ts';

export const getRouteAuthSession = createServerFn({ method: 'GET' }).handler(
	async (): Promise<PublicAuthSession | null> => {
		return toPublicAuthSession(await getAuthSession(getRequest()));
	},
);
